class Animate extends HTMLElement {
  connectedCallback() {
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '-50px',
      threshold: 0,
    });

    this.observer.observe(this);
  }

  onEntry([entry], observer) {
    if (!entry.isIntersecting) return;

    setTimeout(() => {
      this.setAttribute('animated', '');
      observer.unobserve(this);
    }, 200);
  }
}

if (!customElements.get('c2-animate')) {
  customElements.define('c2-animate', Animate);
}
